import { SandboxMessageType } from '@web-studio/shared-schemas';
import { resolveShellPostMessageTarget } from '@/bridge/shellOrigin';

export function postLocaleSelectToShell(locale: string): void {
  if (window.parent === window) {
    return;
  }

  window.parent.postMessage(
    {
      type: SandboxMessageType.LOCALE_SELECT,
      locale,
    },
    resolveShellPostMessageTarget(),
  );
}
